module.exports = __webpack_public_path__ + "img/21_41.2364fb5d.png";